var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin",attrs:{"playsinline":"","controls":""}}),_c('div',{staticClass:"video-overlay"})])}
var staticRenderFns = []

export { render, staticRenderFns }